import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

// Allow callers to attach arbitrary structured fields to the list key (beyond
// the required `identifier`) so consumers can scope/invalidate by domain
// values like `targetService`, `targetServiceIds`, or date ranges without
// having to concatenate everything into the identifier string.
//
// The accepted shape is intentionally `JsonValue`-ish — anything React Query
// can compare structurally. Strings, numbers, booleans, arrays, and plain
// nested objects all work.
type IntegrationQueryKeyValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | IntegrationQueryKeyValue[]
  | { [k: string]: IntegrationQueryKeyValue };

type IntegrationQueryDetailKeyFilter = RequiredQueryKeyFilter & {
  [key: string]: IntegrationQueryKeyValue;
};

type IntegrationQueryListKeyFilter = RequiredQueryKeyFilter & {
  [key: string]: IntegrationQueryKeyValue;
};

export const integrationQueryKeys = createDefaultQueryKeysGenerator<
  IntegrationQueryListKeyFilter,
  IntegrationQueryDetailKeyFilter
>({
  keyDataType: 'integration',
});
